const SERVICE_OPTIONS = [
  { id: "bracelets", label: "Bracelets" },
  { id: "anklets", label: "Anklets" },
  { id: "both", label: "Bracelets & Anklets" },
];

export function ServiceToggle({ value, onChange }) {
  return (
    <div className="mt-5 flex flex-wrap gap-2">
      {SERVICE_OPTIONS.map((s) => (
        <button
          type="button"
          key={s.id}
          data-testid={`booking-service-${s.id}`}
          aria-pressed={value === s.id}
          onClick={() => onChange(s.id)}
          className={`rounded-full px-4 py-2 text-xs font-medium transition-colors duration-300 ${
            value === s.id
              ? "bg-ink text-alabaster"
              : "border border-ink/10 text-stone-500 hover:border-gold hover:text-gold"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
